import { Redirect, Route, Switch } from 'react-router-dom';
import { RoutingPath } from './routing-pass';
import { TestDetailSP } from '../components/sp/pages/test-detail/test-detail.sp';
import { LoginSP } from '../components/sp/pages/login/login.sp';
import { CustomerSP } from '../components/sp/pages/customer/customer.sp';
import { CustomerDetailSP } from '../components/sp/pages/customer-detail/customer-detail.sp';
import { EstimateSP } from '../components/sp/pages/estimate/estimate.sp';
import { EstimateDetailSP } from '../components/sp/pages/estimate-detail/estimate-detail.sp';
import { OrderSP } from '../components/sp/layout/order/order.sp';
import { MaintenanceSP } from '../components/sp/pages/maintenance/maintenance.sp';
import { MaintenanceDetailSP } from '../components/sp/pages/maintenance-detail/maintenance-detail.sp';
import { FileSP } from '../components/sp/pages/file/file.sp';
import { SupportHistorySP } from '../components/sp/pages/support-history/support-history.sp';
import { TestPageSP } from '../components/sp/pages/test-page/test-page.sp';
import { Master } from '../components/pc/pages/master/master';
import { UserAgent } from '../utilities/user-agent';
import { CustomerDetailPC } from '../components/pc/pages/customer-detail/customer-detail.pc';
import { CustomerPC } from '../components/pc/pages/customer/customer.pc';
import { EstimatePC } from '../components/pc/pages/estimate/estimate.pc';
import { LoginPC } from '../components/pc/pages/login/login.pc';
import { OrderPC } from '../components/pc/pages/order/order.pc';
import { SupportHistoryPC } from '../components/pc/pages/support-history/support-history.pc';
import { TestPagePC } from '../components/pc/pages/test-page/test-page.pc';
import { TestDetailPC } from '../components/pc/pages/test-detail/test-detail.pc';
import { EstimateDetailPC } from '../components/pc/pages/maintenance-detail/estimate-detail/estimate-detail.pc';
import { SendPasswordPC } from '../components/pc/pages/password/send-password/send-password.pc';
import { SendPasswordCompletePC } from '../components/pc/pages/password/send-password-complete/send-password-complete';
import { ChangePasswordPC } from '../components/pc/pages/password/change-password/change-password.pc';
import { ChangePasswordErrorPC } from '../components/pc/pages/password/change-password-error/change-password-error.pc';
import { ChangePasswordCompletePC } from '../components/pc/pages/password/change-password-complete/change-password-complete.pc';
import { SendPasswordCompleteSP } from '../components/sp/pages/password/send-password-complete/send-password-complete.sp';
import { ChangePasswordSP } from '../components/sp/pages/password/change-password/change-password.sp';
import { ChangePasswordErrorSP } from '../components/sp/pages/password/change-password-error/change-password-error.sp';
import { ChangePasswordCompleteSP } from '../components/sp/pages/password/change-password-complete/change-password-complete.sp';
import { SendPasswordSP } from '../components/sp/pages/password/send-password/send-password.sp';
import { ProjectDetailSP } from '../components/sp/pages/project-detail/project-detail.sp';
import { ProjectDetailPC } from '../components/pc/pages/project-detail/project-detail.pc';
import { ProjectPC } from '../components/pc/pages/project/project.pc';
import { ProjectSP } from '../components/sp/pages/project/project.sp';
import { SupportHistoryDetailSP } from '../components/sp/pages/support-history-detail/support-history-detail.sp';
import { MaintenancePC } from '../components/pc/pages/maintenance/maintenance.pc';
import { FilePC } from '../components/pc/pages/file/file.pc';
import { FileDetailSP } from '../components/sp/pages/file-detail/file-detail.sp';
import { ExportCsv } from '../components/pc/pages/export-csv/export-csv';
import { AuthRoute } from '../components/auth-route';
import { CallDB } from '../components/pc/pages/call-db/call-db';
import { Config } from '../config/config';
import { OutPage } from '../components/pc/pages/out-page/out-page';

export const Routes = () => (
  UserAgent === 'pc'
    ? (
      <Switch>
        {(Config.mode === 'local' || Config.mode === 'dev')
        && <Route exact path={RoutingPath.testPage} component={TestPagePC} />}
        {(Config.mode === 'local' || Config.mode === 'dev')
        && <Route exact path={RoutingPath.outPage} component={OutPage} />}
        <Route exact path={RoutingPath.callDB} component={CallDB} />
        <Route exact path={`${RoutingPath.testDetail}/:id`} component={TestDetailPC} />
        <Route exact path={RoutingPath.login} component={LoginPC} />
        <Route exact path={RoutingPath.sendPassword} component={SendPasswordPC} />
        <Route exact path={RoutingPath.sendPasswordComplete} component={SendPasswordCompletePC} />
        <Route exact path={RoutingPath.changePassword} component={ChangePasswordPC} />
        <Route
          exact
          path={RoutingPath.userActivate}
          component={() => <ChangePasswordPC isActivate />}
        />
        <Route exact path={RoutingPath.changePasswordError} component={ChangePasswordErrorPC} />
        <Route
          exact
          path={RoutingPath.userActivateError}
          component={() => <ChangePasswordErrorPC isActivate />}
        />
        <Route
          exact
          path={RoutingPath.changePasswordComplete}
          component={ChangePasswordCompletePC}
        />
        <Route
          exact
          path={RoutingPath.userActivateComplete}
          component={() => <ChangePasswordCompletePC isActivate />}
        />
        <AuthRoute path={`${RoutingPath.customerDetail}/:customerID`} component={CustomerDetailPC} />
        <AuthRoute exact path={RoutingPath.customer} component={CustomerPC} />
        <AuthRoute path={`${RoutingPath.projectDetail}/:projectID`} component={ProjectDetailPC} />
        <AuthRoute path={RoutingPath.project} component={ProjectPC} />
        <AuthRoute exact path={RoutingPath.estimate} component={EstimatePC} />
        <AuthRoute path={`${RoutingPath.estimateDetail}/:id`} component={EstimateDetailPC} />
        <AuthRoute path={`${RoutingPath.estimateDetail}`} component={EstimateDetailPC} />
        <AuthRoute exact path={RoutingPath.order} component={OrderPC} />
        <AuthRoute exact path={`${RoutingPath.maintenanceDetail}/:id`} component={MaintenancePC} />
        <AuthRoute exact path={RoutingPath.maintenance} component={MaintenancePC} />
        <AuthRoute exact path={`${RoutingPath.fileDetail}/:id`} component={FilePC} />
        <AuthRoute exact path={RoutingPath.file} component={FilePC} />
        <AuthRoute exact path={`${RoutingPath.supportHistoryDetail}/:id`} component={SupportHistoryPC} />
        <AuthRoute exact path={RoutingPath.supportHistory} component={SupportHistoryPC} />
        <AuthRoute exact path={RoutingPath.exportCsv} component={ExportCsv} />
        <AuthRoute exact path={RoutingPath.master} component={Master} />
        <AuthRoute>
          <Redirect path="/" to={RoutingPath.customer} />
        </AuthRoute>
      </Switch>
    )
    : (
      <Switch>
        {(Config.mode === 'local' || Config.mode === 'dev')
        && <Route exact path={RoutingPath.testPage} component={TestPageSP} />}
        {(Config.mode === 'local' || Config.mode === 'dev')
        && <Route exact path={RoutingPath.outPage} component={OutPage} />}
        <Route exact path={`${RoutingPath.testDetail}/:id`} component={TestDetailSP} />
        <Route exact path={RoutingPath.login} component={LoginSP} />
        <Route exact path={RoutingPath.sendPassword} component={SendPasswordSP} />
        <Route exact path={RoutingPath.sendPasswordComplete} component={SendPasswordCompleteSP} />
        <Route exact path={RoutingPath.changePassword} component={ChangePasswordSP} />
        <Route
          exact
          path={RoutingPath.userActivate}
          component={() => <ChangePasswordSP isActivate />}
        />
        <Route exact path={RoutingPath.changePasswordError} component={ChangePasswordErrorSP} />
        <Route
          exact
          path={RoutingPath.userActivateError}
          component={() => <ChangePasswordErrorSP isActivate />}
        />
        <Route
          exact
          path={RoutingPath.changePasswordComplete}
          component={ChangePasswordCompleteSP}
        />
        <Route
          exact
          path={RoutingPath.userActivateComplete}
          component={() => <ChangePasswordCompleteSP isActivate />}
        />
        <AuthRoute path={`${RoutingPath.customerDetail}/:customerID`} component={CustomerDetailSP} />
        <AuthRoute exact path={RoutingPath.customer} component={CustomerSP} />
        <AuthRoute path={`${RoutingPath.projectDetail}/:projectID`} component={ProjectDetailSP} />
        <AuthRoute exact path={RoutingPath.project} component={ProjectSP} />
        <AuthRoute exact path={RoutingPath.estimate} component={EstimateSP} />
        <AuthRoute exact path={`${RoutingPath.estimateDetail}/:id`} component={EstimateDetailSP} />
        <AuthRoute exact path={RoutingPath.order} component={OrderSP} />
        <AuthRoute exact path={RoutingPath.maintenance} component={MaintenanceSP} />
        <AuthRoute exact path={`${RoutingPath.maintenanceDetail}/:id`} component={MaintenanceDetailSP} />
        <AuthRoute exact path={RoutingPath.file} component={FileSP} />
        <AuthRoute exact path={`${RoutingPath.fileDetail}/:id/:file`} component={FileDetailSP} />
        <AuthRoute exact path={RoutingPath.supportHistory} component={SupportHistorySP} />
        <AuthRoute exact path={`${RoutingPath.supportHistoryDetail}/:id`} component={SupportHistoryDetailSP} />
        <AuthRoute>
          <Redirect path="/" to={RoutingPath.customer} />
        </AuthRoute>
      </Switch>
    )
);
